import { useEffect, useState } from 'react';
import { ICalculationInfo } from '../../../redux/Calculations/CurrentCalculationSessionInterface';
import FetchData from '../../ServerCall/FetchData';

export const useCalculation = (
  orderListOfSlows: string[],
  calculationInfo: ICalculationInfo,
  calculationName: string,
  url: string,
) => {
  const [data, setData] = useState<{ datas: any[]; key: string } | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      const newSortedFlows: { [key: string]: any } = {};
      for (const flow of orderListOfSlows) {
        newSortedFlows[flow] = calculationInfo.flows[flow];
      }
      const updatedCalculationInfo = {
        ...calculationInfo,
        flows: newSortedFlows,
        calculatedFieldName: calculationName,
      };
      try {
        const response = await FetchData({
          requestType: 'withData',
          method: 'POST',
          url: url,
          headers: { 'Content-Type': 'application/json' },
          data: [updatedCalculationInfo],
        });
        setData({
          datas: response.data,
          key: Object.keys(response.data[0])[0],
        });
      } catch (e: any) {
        setError({ message: e.message, code: e.code || 500, isError: true });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [orderListOfSlows, calculationInfo, url]);

  return { result: data, loading, error };
};
